import * as Yup from "yup";
import { version } from "./version";

const {
  formField: { configFile },
} = version;

export const connectorVersionValidation = Yup.object().shape({
  [configFile.name]: Yup.string().required(configFile.errorMsg),
});
